<template>
    <PopForm :state="state" width="990px" body-max-height="560px">
        <template v-slot:title>查找会员</template>
        <!--搜索会员-->
        <div class="search-user-box">
            <search-user @searched="userSearched" ref="searchDom"></search-user>
            <el-button @click="clearUser">清除会员</el-button>
        </div>

        <div class="body">
            <!--会员信息-->
            <div class="user-info-box">
                <user-info :user-info="userInfo" v-if="userInfo.store_uid"></user-info>
                <div v-else class="empty-box">暂无数据</div>
            </div>
        </div>
        <template v-slot:foot>
            <div class="foot">
                <div class="btn-box">
                    <el-button type="primary" @click="close">关闭</el-button>
                </div>
            </div>
        </template>
    </PopForm>
</template>

<script>
    import obj from "@/js/obj";
    import ElCollapseTransition from "element-ui/lib/transitions/collapse-transition";
    import UserInfo from "@/model/Cash/UserInfo";
    import SearchUser from "@/model/Cash/SearchUser";
    import PopForm from "@/model/PopForm";
    export default {
        name: "SearchUserBox",
        components: {PopForm, SearchUser, UserInfo, ElCollapseTransition},
        model: {
            prop: "state",
            event: "show",
        },
        props: {
            state: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            tableData: [],
            searchValue: "",

            userInfo: {},
        }),
        mounted: function () {

        },
        methods: {
            //搜索会员结果
            userSearched: function (userInfo) {
                this.userInfo = userInfo;
                // obj.postData("store_user/get_store_user_info", {id: userInfo.store_uid}, res => {
                //     if(res.errcode === 0) {
                //         res.data.store_uid = res.data.id;
                //         this.userInfo = res.data;
                //     }else
                //         obj.message.error(res.errdesc);
                // });
            },
            //清除会员
            clearUser: function () {
                this.userInfo = {};
                if(this.$refs.searchDom)
                    this.$refs.searchDom.clearSearchValue();
            },
            //关闭
            close: function () {
                this.clearUser();
                this.$emit("show", false);
            },
        },
        watch: {

        }
    }
</script>

<style scoped>
    .search-box{
        padding: 6px 10px 0 6px;
    }
    .search-box .el-input-group{
        width: 380px;
    }
    .body{
        padding: 16px 6px 0;
        height: 402px;
        overflow: auto;
    }
    .body .el-table, .body .el-table:before{
        background-color: transparent;
        border: none;
    }
    .btn-box{
        padding: 0 20px 10px;
        text-align: right;
    }
    .empty-box{
        height: 402px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #909399;
    }
</style>
<style>
    .user-list-table th{
        background-color: #f4f4f4;
    }
    .user-list-table.el-table td, .temp-order-list.el-table th{
        padding-top: 9px;
        padding-bottom: 9px;
    }
    .user-list-table .el-table__body{
        width: 100% !important;
    }
    .user-list-table .el-table__row{
        cursor: pointer;
    }
</style>
